import React, { Component } from 'react';
import Icon from '@mdi/react';

import './PageTitle.css';

const PageTitle = ({ tag, title, actions, icon, children}) => {
    const Tag = tag || 'h3';

    return (
        <Tag className="PageTitle">
            <div className="clearfix" style={{ padding: '.5rem' }}>
                <div className="pull-left">
                    { icon && (
                        <>
                            <Icon path={icon} size={1.5} />&nbsp;
                        </>
                    )}
                    { title }
                </div>
                <div className="pull-right">
                    { actions}
                </div>
            </div>
            { children }
        </Tag>
    );
}

export default PageTitle;
